var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 39,
    viewBox: "0 0 50 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_379_32568)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_379_32568",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 52,
    height: 39
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000976562 0.540329H50.0015V38.0403H-0.000976562V0.540329Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_379_32568)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000976562 0.540409H50.0088V38.0404H-0.000976562V0.540409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47998 11.9291L10.6819 4.12972L11.9819 4.99662L6.77994 12.796L5.47998 11.9291ZM7.42992 13.2295L12.6319 5.43007L13.9318 6.29697L8.72987 14.0964L7.42992 13.2295ZM9.37985 14.5298L14.5818 6.73042L15.8817 7.59732L10.6798 15.3967L9.37985 14.5298Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47998 11.9291L10.6819 4.12972L11.9819 4.99662L6.77994 12.796L5.47998 11.9291ZM7.42992 13.2295L12.6319 5.43007L13.9318 6.29697L8.72987 14.0964L7.42992 13.2295ZM9.37985 14.5298L14.5818 6.73042L15.8817 7.59732L10.6798 15.3967L9.37985 14.5298Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 31.7997L40.2019 24.0004L41.5019 24.8673L36.3 32.6666L35 31.7997ZM36.9499 33.1001L42.1519 25.3007L43.4518 26.1676L38.2499 33.967L36.9499 33.1001ZM38.8999 34.4005L44.1018 26.6011L45.4018 27.468L40.1998 35.2674L38.8999 34.4005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 31.7997L40.2019 24.0004L41.5019 24.8673L36.3 32.6666L35 31.7997ZM36.9499 33.1001L42.1519 25.3007L43.4518 26.1676L38.2499 33.967L36.9499 33.1001ZM38.8999 34.4005L44.1018 26.6011L45.4018 27.468L40.1998 35.2674L38.8999 34.4005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 27.5L43.4996 31.8347Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 27.5L43.4996 31.8347",
    stroke: "white",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1803 14.0979C18.5599 12.0294 20.7047 10.5935 23.1429 10.1063C25.5811 9.61914 28.113 10.1205 30.1815 11.5C32.2501 12.8796 33.6859 15.0244 34.1731 17.4626C34.6603 19.9008 34.159 22.4327 32.7794 24.5013L17.1803 14.0979Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1803 14.0979C15.8007 16.1665 15.2994 18.6984 15.7866 21.1366C16.2738 23.5748 17.7096 25.7196 19.7782 27.0992C21.8468 28.4787 24.3787 28.9801 26.8169 28.4929C29.2551 28.0057 31.3999 26.5699 32.7795 24.5013C33.4692 23.467 33.7199 22.201 33.4763 20.9819C33.2327 19.7628 32.5148 18.6904 31.4805 18.0007C30.4462 17.3109 29.1803 17.0602 27.9612 17.3038C26.7421 17.5474 25.6697 18.2653 24.9799 19.2996L17.1803 14.0979Z",
    fill: "#0047A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9799 19.2996C26.4163 17.1458 25.8347 14.2354 23.6809 12.799C21.5271 11.3626 18.6167 11.9441 17.1803 14.0979C15.7439 16.2517 16.3255 19.1622 18.4793 20.5986C20.633 22.035 23.5435 21.4534 24.9799 19.2996Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7006 34.475L5.49889 26.6754L6.79882 25.8085L12.0005 33.608L10.7006 34.475ZM12.6505 33.1746L7.44879 25.375L8.74871 24.5081L13.9504 32.3076L12.6505 33.1746ZM14.6003 31.8742L9.39868 24.0746L10.6986 23.2076L15.9003 31.0072L14.6003 31.8742Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7006 34.475L5.49889 26.6754L6.79882 25.8085L12.0005 33.608L10.7006 34.475ZM12.6505 33.1746L7.44879 25.375L8.74871 24.5081L13.9504 32.3076L12.6505 33.1746ZM14.6003 31.8742L9.39868 24.0746L10.6986 23.2076L15.9003 31.0072L14.6003 31.8742Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72461 29.4915L11.6745 28.1911ZM36.0482 11.9359L38.323 10.4187ZM40.2729 9.11832L42.2228 7.8179Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72461 29.4915L11.6745 28.1911M36.0482 11.9359L38.323 10.4187M40.2729 9.11832L42.2228 7.8179",
    stroke: "white",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6772 3.97064L44.8506 11.789L43.5475 12.6512L38.3742 4.83286L39.6772 3.97064ZM37.7227 5.26398L42.896 13.0824L41.5929 13.9446L36.4196 6.1262L37.7227 5.26398ZM35.7681 6.55732L40.9414 14.3757L39.6384 15.2379L34.465 7.41954L35.7681 6.55732Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6772 3.97064L44.8506 11.789L43.5475 12.6512L38.3742 4.83286L39.6772 3.97064ZM37.7227 5.26398L42.896 13.0824L41.5929 13.9446L36.4196 6.1262L37.7227 5.26398ZM35.7681 6.55732L40.9414 14.3757L39.6384 15.2379L34.465 7.41954L35.7681 6.55732Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4999 10.5001L36.9998 11.5001ZM11.4546 27.9266L9.5 29.22Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4999 10.5001L36.9998 11.5001M11.4546 27.9266L9.5 29.22M42.5 8.00005L40.9999 9.00005",
    stroke: "white",
    strokeWidth: 1.25
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_379_32568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 37.5,
    fill: "white",
    transform: "translate(0 0.538452)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/kr.41d4669641f3bf87d88b7f197c1c5c0c.svg";
export { ForwardRef as ReactComponent };